module.exports = __webpack_public_path__ + "657b55ae150d260de57a1fa3ecdec091.woff2";